import requestv2 from "~/utils/http-v2";

const formSabbaticalApi = {
	gets : async (params) => {
		const url = 'v2/form/sabbatical';
		return await requestv2.get(url, {params});
	},
	count : async (params) => {
		const url = 'v2/form/sabbatical/count';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/form/sabbatical';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/form/sabbatical/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete : async (id) => {
		const url = `v2/form/sabbatical/${id}`;
		return await requestv2.delete(url);
	},
	status : async (params) => {
		const url = `v2/form/sabbatical/status/${params.id}`;
		return await requestv2.post(url, params);
	},
};

export default formSabbaticalApi;